import React from 'react';

import TextBox from '../../../../ui/TextBox';

import { now } from '../../../../dateUtils';
import InlineInputControlRow from '../../../../ui/layout/InlineInputControlRow';
import InlineInputControlRowNoLabel from '../../../../ui/layout/InlineInputControlRowNoLabel';
import { HblStatusViewModel } from '../../../../fms.core/HblStatusViewModel';
import BlueTitleRow from '../../../../ui/BlueTitleRow';
import BlStatusRow from '../../../common/BlStatusRow';

function HblMilestone({
  hblNo,
  hbl,
  onChange,
  isEdit,
  isView,
  user
}: {
  hblNo: string,
  hbl: HblStatusViewModel,
  onChange: (x:Partial<HblStatusViewModel>) => void,
  user: string,
  isEdit: boolean,
  isView: boolean,
}) {
  // function toggleTimestampProperty(name:string, value:boolean) {
  //   const change:Partial<OceanImportHbl> = {};

  //   if (value) {
  //     const timestamp = now();
  //     change[name] = timestamp;
  //     change[`${name}User`] = user;
  //   } else {
  //     change[name] = null;
  //     change[`${name}User`] = null;
  //   }

  //   onChange(change);
  // }

  // function onTimestampPropertyChange(name:string, value:string|null) {
  //   const change:Partial<OceanImportHbl> = {};
  //   change[name] = value;
  //   onChange(change);
  // }

  return (
    <div>
      <div style={{display: 'flex'}}>
        <div style={{width: '325px'}}>
          <div style={{marginLeft: '30px'}}>
            <InlineInputControlRow label="HBL #" bold mode="w115">
              <div style={{width: '130px'}}>
                <TextBox disabled value={hblNo} />
              </div>
            </InlineInputControlRow>
          </div>
        </div>

        <div style={{marginLeft: '30px', width: '325px'}}>
        </div>
      </div>

      <div style={{display: 'flex'}}>
        <div style={{width: '325px'}}>
          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Original B/L Required"
              disabled
              checked={hbl.origReq}
              noStatus
              onToggle={() => {
                //window.console.log(checked);
              }}
              labelColor={'blue'}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              name ='HblMilestone-detail-origRec'
              label="Original B/L Received"
              disabled={isView}
              checked={!!hbl.oblRcvd}
              onToggle={oblRcvd => onChange({
                oblRcvd,
                oblCol: oblRcvd ? '1' : '0',
                oblDate: oblRcvd ? now() : null,
                oblBy: oblRcvd ? user : '',
                })}
              dateTime={hbl.oblDate}
              onDateTimeChange={oblDate => onChange({oblDate, oblBy: oblDate ? hbl.oblBy : '', oblRcvd: oblDate ? hbl.oblRcvd : false})}
              userId={hbl.oblBy}
              labelColor={'blue'}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
            name ='HblMilestone-detail-cargRel'
              label="Cargo Release"
              disabled={isView || ['2', '3'].includes(hbl.customsStatus) || hbl.fdaHold}
              checked={!!hbl.rlsd}
              onToggle={rlsd => onChange({
                rlsd,
                rlsDate: rlsd ? now() : null,
                rlsdBy: rlsd ? user : '',
                })}
              dateTime={hbl.rlsDate}
              onDateTimeChange={rlsDate => onChange({rlsDate, rlsdBy: rlsDate ? hbl.rlsdBy : '', rlsd: rlsDate ? hbl.rlsd : false})}
              userId={hbl.rlsdBy}
              labelColor={'blue'}
            />
          </InlineInputControlRowNoLabel>
        </div>

        <div style={{marginLeft: '30px', width: '325px'}}>
          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="AMS Downloaded"
              disabled
              checked={!!hbl.amsLinkId}
              noStatus
              onToggle={() => {
                //window.console.log(checked);
              }}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="OP Close"
              disabled
              checked={hbl.opClosed}
              onToggle={() => {
                //window.console.log(checked);
              }}
              dateTime={hbl.opCloseDate}
              onDateTimeChange={() => {}}
              userId={hbl.opClosedBy}
              showDatePlaceHolder={false}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Period Close"
              disabled
              checked={hbl.actClosed}
              onToggle={() => {
                //window.console.log(checked);
              }}
              dateTime={hbl.actClosed ? hbl.actCloseDate : ''}
              onDateTimeChange={() => {}}
              userId={hbl.actClosed ? hbl.actClosedBy : ''}
              showDatePlaceHolder={false}
            />
          </InlineInputControlRowNoLabel>
        </div>
      </div>

      <div style={{marginTop: '10px'}}>
        <BlueTitleRow title={<span style={{paddingLeft: '14px'}}>B/L Status</span>} />
      </div>

      <div style={{display: 'flex'}}>
        <div style={{width: '325px'}}>
          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Tracker"
              disabled={isView}
              checked={!!hbl.trackerChk}
              onToggle={trackerChk => onChange({
                trackerChk,
                trackerDate: trackerChk ? now() : null,
                trackerBy: trackerChk ? user : '',
                })}
              dateTime={hbl.trackerDate}
              onDateTimeChange={trackerDate => onChange({trackerDate, trackerBy: trackerDate ? hbl.trackerBy : '', trackerChk: trackerDate ? hbl.trackerChk : false})}
              userId={hbl.trackerBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Last Tracked"
              disabled={isView}
              checked={!!hbl.lastTrackChk}
              onToggle={lastTrackChk => onChange({
                lastTrackChk,
                lastTrackDate: lastTrackChk ? now() : null,
                lastTrackBy: lastTrackChk ? user : '',
                })}
              dateTime={hbl.lastTrackDate}
              onDateTimeChange={lastTrackDate => onChange({lastTrackDate, lastTrackBy: lastTrackDate ? hbl.lastTrackBy : '', lastTrackChk: lastTrackDate ? hbl.lastTrackChk : false})}
              userId={hbl.lastTrackBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Send Arrival Notice"
              disabled={isView}
              checked={!!hbl.anPrtChk}
              onToggle={anPrtChk => onChange({
                anPrtChk,
                anPrtDate: anPrtChk ? now() : null,
                anPrtBy: anPrtChk ? user : '',
                })}
              dateTime={hbl.anPrtDate}
              onDateTimeChange={anPrtDate => onChange({anPrtDate, anPrtBy: anPrtDate ? hbl.anPrtBy : '', anPrtChk: anPrtDate ? hbl.anPrtChk : false})}
              userId={hbl.anPrtBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Receive Comm. Docs"
              disabled={isView}
              checked={!!hbl.commDocChk}
              onToggle={commDocChk => onChange({
                commDocChk,
                commDocDate: commDocChk ? now() : null,
                commDocBy: commDocChk ? user : '',
                })}
              dateTime={hbl.commDocDate}
              onDateTimeChange={commDocDate => onChange({commDocDate, commDocBy: commDocDate ? hbl.commDocBy : '', commDocChk: commDocDate ? hbl.commDocChk : false})}
              userId={hbl.commDocBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Send E. Docs to Broker"
              disabled={isView}
              checked={!!hbl.entryDocChk}
              onToggle={entryDocChk => onChange({
                entryDocChk,
                entryDocDate: entryDocChk ? now() : null,
                entryDocBy: entryDocChk ? user : '',
                })}
              dateTime={hbl.entryDocDate}
              onDateTimeChange={entryDocDate => onChange({entryDocDate, entryDocBy: entryDocDate ? hbl.entryDocBy : '', entryDocChk: entryDocDate ? hbl.entryDocChk : false})}
              userId={hbl.entryDocBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Receive 7501 Docs"
              disabled={isView}
              checked={!!hbl.f7501Chk}
              onToggle={f7501Chk => onChange({
                f7501Chk,
                f7501Date: f7501Chk ? now() : null,
                f7501By: f7501Chk ? user : '',
                })}
              dateTime={hbl.f7501Date}
              onDateTimeChange={f7501Date => onChange({f7501Date, f7501By: f7501Date ? hbl.f7501By : '', f7501Chk: f7501Date ? hbl.f7501Chk : false})}
              userId={hbl.f7501By}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Receive 3461 Docs"
              disabled={isView}
              checked={!!hbl.f3461Chk}
              onToggle={f3461Chk => onChange({
                f3461Chk,
                f3461Date: f3461Chk ? now() : null,
                f3461By: f3461Chk ? user : '',
                })}
              dateTime={hbl.f3461Date}
              onDateTimeChange={f3461Date => onChange({f3461Date, f3461By: f3461Date ? hbl.f3461By : '', f3461Chk: f3461Date ? hbl.f3461Chk : false})}
              userId={hbl.f3461By}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Customs Clearance"
              disabled={isView}
              checked={hbl.customsStatus === '1' || hbl.customsStatus === '3'}
              onToggle={value => onChange({
                customsStatus: value ? (hbl.customsStatus === '2' ? '3' : '1') : (hbl.customsStatus === '3' ? '2' : '0'),
                cClearDate: value ? now() : null,
                cClearBy: value ? user : '',
                })}
              dateTime={hbl.cClearDate}
              onDateTimeChange={cClearDate => onChange({
                cClearDate,
                cClearBy: cClearDate ? hbl.cClearBy : '',
                customsStatus: cClearDate ? hbl.customsStatus : (hbl.customsStatus === '3' ? '2' : '0')
              })}
              userId={hbl.cClearBy}
              labelColor='blue'
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Customs Hold"
              disabled={isView || !!hbl.isClear}
              checked={['2', '3'].includes(hbl.customsStatus)}
              onToggle={value => onChange({
                customsStatus: value ? (hbl.customsStatus === '1' ? '3' : '2') : (hbl.customsStatus === '3' ? '1' : '0'),
                cHoldDate: value ? now() : null,
                cHoldBy: value ? user : '',

                //Reset Cargo Release
                rlsd : false,
                rlsDate: null,
                rlsdBy: '',
                })}
              dateTime={hbl.cHoldDate}
              onDateTimeChange={cHoldDate => onChange({
                cHoldDate,
                cHoldBy: cHoldDate ? hbl.cHoldBy : '',
                customsStatus: cHoldDate ? hbl.customsStatus : (hbl.customsStatus === '3' ? '1' : '0')
              })}
              userId={hbl.cHoldBy}
              labelColor='blue'
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Customs Release"
              disabled={isView}
              checked={!!hbl.isClear}
              onToggle={isClear => onChange({
                customsStatus: hbl.customsStatus === '3' ? '1' : (hbl.customsStatus === '2' ? '0' : hbl.customsStatus),
                isClear,
                cReleaseDate: isClear ? now() : null,
                cReleaseBy: isClear ? user : '',
                
                // Reset Customs Hold
                cHoldDate: null,
                cHoldBy: '',
                })}
              dateTime={hbl.cReleaseDate}
              onDateTimeChange={cReleaseDate => onChange({cReleaseDate, cReleaseBy: cReleaseDate ? hbl.cReleaseBy : '', isClear: cReleaseDate ? hbl.isClear : false})}
              userId={hbl.cReleaseBy}
              labelColor='blue'
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Exam On"
              disabled={isView}
              checked={!!hbl.examOnChk}
              onToggle={examOnChk => onChange({
                examOnChk,
                examOnDate: examOnChk ? now() : null,
                examOnBy: examOnChk ? user : '',
                })}
              dateTime={hbl.examOnDate}
              onDateTimeChange={examOnDate => onChange({examOnDate, examOnBy: examOnDate ? hbl.examOnBy : '', examOnChk: examOnDate ? hbl.examOnChk : false})}
              userId={hbl.examOnBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Exam Off"
              disabled={isView}
              checked={!!hbl.examOffChk}
              onToggle={examOffChk => onChange({
                examOffChk,
                examOffDate: examOffChk ? now() : null,
                examOffBy: examOffChk ? user : '',
                })}
              dateTime={hbl.examOffDate}
              onDateTimeChange={examOffDate => onChange({examOffDate, examOffBy: examOffDate ? hbl.examOffBy : '', examOffChk: examOffDate ? hbl.examOffChk : false})}
              userId={hbl.examOffBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="PGA Hold"
              disabled={isView || !!hbl.fdaRls/* || (hbl.customsStatus === '2' || hbl.customsStatus === '3')*/}
              checked={!!hbl.fdaHold}
              onToggle={fdaHold => onChange({
                fdaHold,
                fdaHoldDate: fdaHold ? now() : null,
                fdaHoldBy: fdaHold ? user : '',
                
                //Reset Cargo Release
                rlsd : false,
                rlsDate: null,
                rlsdBy: '',
                })}
              dateTime={hbl.fdaHoldDate}
              onDateTimeChange={fdaHoldDate => onChange({fdaHoldDate, fdaHoldBy: fdaHoldDate ? hbl.fdaHoldBy : '', fdaHold: fdaHoldDate ? hbl.fdaHold : false})}
              userId={hbl.fdaHoldBy}
              labelColor='blue'
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="PGA Release"
              disabled={isView}
              checked={!!hbl.fdaRls}
              onToggle={fdaRls => onChange({
                fdaRls,
                fdaRlsDate: fdaRls ? now() : null,
                fdaRlsBy: fdaRls ? user : '',

                //Reset PGA Hold
                fdaHold: false,
                fdaHoldDate : null,
                fdaHoldBy : '',
                })}
              dateTime={hbl.fdaRlsDate}
              onDateTimeChange={fdaRlsDate => onChange({fdaRlsDate, fdaRlsBy: fdaRlsDate ? hbl.fdaRlsBy : '', fdaRls: fdaRlsDate ? hbl.fdaRls : false})}
              userId={hbl.fdaRlsBy}
              labelColor='blue'
            />
          </InlineInputControlRowNoLabel>
        </div>

        <div style={{marginLeft: '30px', width: '325px'}}>
          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Send I.T Notice"
              disabled={isView}
              checked={!!hbl.inlandNtcChk}
              onToggle={inlandNtcChk => onChange({
                inlandNtcChk,
                inlandNtcDate: inlandNtcChk ? now() : null,
                inlandNtcBy: inlandNtcChk ? user : '',
                })}
              dateTime={hbl.inlandNtcDate}
              onDateTimeChange={inlandNtcDate => onChange({inlandNtcDate, inlandNtcBy: inlandNtcDate ? hbl.inlandNtcBy : '', inlandNtcChk: inlandNtcDate ? hbl.inlandNtcChk : false})}
              userId={hbl.inlandNtcBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Send Pickup Info"
              disabled={isView}
              checked={!!hbl.puSentChk}
              onToggle={puSentChk => onChange({
                puSentChk,
                puSentDate: puSentChk ? now() : null,
                puSentBy: puSentChk ? user : '',
                })}
              dateTime={hbl.puSentDate}
              onDateTimeChange={puSentDate => onChange({puSentDate, puSentBy: puSentDate ? hbl.puSentBy : '', puSentChk: puSentDate ? hbl.puSentChk : false})}
              userId={hbl.puSentBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Confirm DO Receipt"
              disabled={isView}
              checked={!!hbl.doConfirmChk}
              onToggle={doConfirmChk => onChange({
                doConfirmChk,
                doConfirmDate: doConfirmChk ? now() : null,
                doConfirmBy: doConfirmChk ? user : '',
                })}
              dateTime={hbl.doConfirmDate}
              onDateTimeChange={doConfirmDate => onChange({doConfirmDate, doConfirmBy: doConfirmDate ? hbl.doConfirmBy : '', doConfirmChk: doConfirmDate ? hbl.doConfirmChk : false})}
              userId={hbl.doConfirmBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Confirm Delivery Add"
              disabled={isView}
              checked={!!hbl.delAddrChk}
              onToggle={delAddrChk => onChange({
                delAddrChk,
                delAddrDate: delAddrChk ? now() : null,
                delAddrBy: delAddrChk ? user : '',
                })}
              dateTime={hbl.delAddrDate}
              onDateTimeChange={delAddrDate => onChange({delAddrDate, delAddrBy: delAddrDate ? hbl.delAddrBy : '', delAddrChk: delAddrDate ? hbl.delAddrChk : false})}
              userId={hbl.delAddrBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Send DO"
              disabled={isView}
              checked={!!hbl.doSentChk}
              onToggle={doSentChk => onChange({
                doSentChk,
                doSentDate: doSentChk ? now() : null,
                doSentBy: doSentChk ? user : '',
                })}
              dateTime={hbl.doSentDate}
              onDateTimeChange={doSentDate => onChange({doSentDate, doSentBy: doSentDate ? hbl.doSentBy : '', doSentChk: doSentDate ? hbl.doSentChk : false})}
              userId={hbl.doSentBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Est. Delivery Date"
              disabled={isView}
              checked={!!hbl.delSchedChk}
              onToggle={delSchedChk => onChange({
                delSchedChk,
                delSchedDate: delSchedChk ? now() : null,
                delSchedBy: delSchedChk ? user : '',
                })}
              dateTime={hbl.delSchedDate}
              onDateTimeChange={delSchedDate => onChange({delSchedDate, delSchedBy: delSchedDate ? hbl.delSchedBy : '', delSchedChk: delSchedDate ? hbl.delSchedChk : false})}
              userId={hbl.delSchedBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Actual Delivery Date"
              disabled={isView}
              checked={!!hbl.delActChk}
              onToggle={delActChk => onChange({
                delActChk,
                delActDate: delActChk ? now() : null,
                delActBy: delActChk ? user : '',
                })}
              dateTime={hbl.delActDate}
              onDateTimeChange={delActDate => onChange({delActDate, delActBy: delActDate ? hbl.delActBy : '', delActChk: delActDate ? hbl.delActChk : false})}
              userId={hbl.delActBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Return Empty CNTR"
              disabled={isView}
              checked={!!hbl.emptyRetChk}
              onToggle={emptyRetChk => onChange({
                emptyRetChk,
                emptyRetDate: emptyRetChk ? now() : null,
                emptyRetBy: emptyRetChk ? user : '',
                })}
              dateTime={hbl.emptyRetDate}
              onDateTimeChange={emptyRetDate => onChange({emptyRetDate, emptyRetBy: emptyRetDate ? hbl.emptyRetBy : '', emptyRetChk: emptyRetDate ? hbl.emptyRetChk : false})}
              userId={hbl.emptyRetBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Receive POD"
              disabled={isView}
              checked={!!hbl.podChk}
              onToggle={podChk => onChange({
                podChk,
                podDate: podChk ? now() : null,
                podBy: podChk ? user : '',
                })}
              dateTime={hbl.podDate}
              onDateTimeChange={podDate => onChange({podDate, podBy: podDate ? hbl.podBy : '', podChk: podDate ? hbl.podChk : false})}
              userId={hbl.podBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Complete Billing"
              disabled={isView}
              checked={!!hbl.billChk}
              onToggle={billChk => onChange({
                billChk,
                billDate: billChk ? now() : null,
                billBy: billChk ? user : '',
                })}
              dateTime={hbl.billDate}
              onDateTimeChange={billDate => onChange({billDate, billBy: billDate ? hbl.billBy : '', billChk: billDate ? hbl.billChk : false})}
              userId={hbl.billBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Billing Packet Mailed"
              disabled={isView}
              checked={!!hbl.billPacketChk}
              onToggle={billPacketChk => onChange({
                billPacketChk,
                billPacketDate: billPacketChk ? now() : null,
                billPacketBy: billPacketChk ? user : '',
                })}
              dateTime={hbl.billPacketDate}
              onDateTimeChange={billPacketDate => onChange({billPacketDate, billPacketBy: billPacketDate ? hbl.billPacketBy : '', billPacketChk: billPacketDate ? hbl.billPacketChk : false})}
              userId={hbl.billPacketBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Delivery Duty Paid"
              disabled={isView}
              checked={!!hbl.ddpChk}
              onToggle={ddpChk => onChange({
                ddpChk,
                ddpDate: ddpChk ? now() : null,
                ddpBy: ddpChk ? user : '',
                })}
              dateTime={hbl.ddpDate}
              onDateTimeChange={ddpDate => onChange({ddpDate, ddpBy: ddpDate ? hbl.ddpBy : '', ddpChk: ddpDate ? hbl.ddpChk : false})}
              userId={hbl.ddpBy}
            />
          </InlineInputControlRowNoLabel>
        </div>
      </div>
    </div>
  );
}

export default React.memo(HblMilestone);
